<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre8" id="pgepubid00000">ANGEL</h1>
<h2 class="sigil_not_in_toc">A sketch in Indian ink</h2>
<h2 class="sigil_not_in_toc">B. M. Croker</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1beb1cc0